import React from "react";

export const TncLogo = ({
  width = "30",
  height = "30",
  fill = "none",
  color = "white",
}) => (
  <svg
    width={width}
    height={height}
    fill={fill}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginTop: "5px" }}
  >
    <path
      d="M4.15479 15.9849C4.16797 17.018 4.23554 17.4532 4.58209 17.8461C5.0126 18.3343 5.70549 18.3343 7.09128 18.3343H12.8849C14.2707 18.3343 14.9636 18.3343 15.3941 17.8461C15.7407 17.4532 15.8083 17.018 15.8214 15.9849"
      stroke={color}
      stroke-opacity="0.6"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.99056 15.8921H3.96411C3.3658 15.8921 2.84823 15.4041 2.92343 14.8105C3.05598 13.7642 3.58796 12.4994 5.69666 11.7216C6.43795 11.4481 7.25415 11.2114 7.65632 10.5313C8.22079 9.57675 8.46956 8.53192 7.41672 6.74008C5.69666 3.35025 8.2703 1.66602 10.0095 1.66602C11.7486 1.66602 14.2907 3.45725 12.5536 6.74008C11.4988 8.51733 11.7791 9.57675 12.3436 10.5313C12.7458 11.2114 13.562 11.4481 14.3033 11.7216C16.412 12.4994 16.944 13.7642 17.0765 14.8105C17.1517 15.4041 16.6341 15.8921 16.0358 15.8921H10.0094"
      stroke={color}
      stroke-opacity="0.6"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
